import React, { Component } from 'react';
import CommonFunctions from './CommonFunctions';

export default class LearnPanel extends Component {
	constructor(props) {
	    super(props);

		// Клонуємо масив фраз, фільтруємо, перемішуємо.
		this.phrases = CommonFunctions.shuffleArray(
				CommonFunctions.filterPhrases(this.props.app.phrases.slice())
				.filter(v => !this.props.app.unselectedPhrases.includes(v[0]))
				);

		this.currentPhraseIndex = -1;
		this.isLearnPaused = false;
		this.intervalBetweenPhrases = parseInt(CommonFunctions.getSetting(
				'intervalBetweenPhrases', '4'), 10);

		this.readCurrentPhrase = this.readCurrentPhrase.bind(this);
		this.goToPreviousPhrase = this.goToPreviousPhrase.bind(this);
		this.goToNextPhrase = this.goToNextPhrase.bind(this);
		this.resumeOrPauseLearn = this.resumeOrPauseLearn.bind(this);
		this.finishLearn = this.finishLearn.bind(this);
		this.state = this.getNextState();
	}

	getCurrentState() {
		return {
			isLearnPaused: this.isLearnPaused,
			// Поточна фраза та переклад.
			currentPhraseIndex: this.currentPhraseIndex,
			currentPhrase: this.phrases[this.currentPhraseIndex]};
	}

	getNextState() {
		this.currentPhraseIndex++;
		this.readPhrase();
		return this.getCurrentState();
	}

	goToNextState() {
		if (this.currentPhraseIndex !== (this.phrases.length - 1)
				&& !this.isLearnPaused) this.setState(this.getNextState());
	}

	readPhrase() {
		let phrase = this.phrases[this.currentPhraseIndex][0];
		setTimeout(() => {
			CommonFunctions.speak(
				phrase,
				() => { // onEnd
					if (this.intervalBetweenPhrases === 0)
						this.goToNextState();
					else
						setTimeout(
								() => { this.goToNextState(); },
								this.intervalBetweenPhrases * 1000);
				});
		}, parseInt(CommonFunctions.getSetting(
				'readingDelayInLearning', 800), 10))
	}

	readCurrentPhrase() {
		CommonFunctions.speak(this.phrases[this.currentPhraseIndex][0]);
	}

	goToPreviousPhrase() {
		this.isLearnPaused = true;
		if (this.currentPhraseIndex) {
			this.currentPhraseIndex--;
			this.readCurrentPhrase();
		}
		this.setState(this.getCurrentState());
	}

	goToNextPhrase() {
		this.isLearnPaused = true;
		if (this.currentPhraseIndex === (this.phrases.length - 1))
			this.setState(this.getCurrentState());
		else
			this.setState(this.getNextState());
	}

	resumeOrPauseLearn() {
		this.isLearnPaused = !this.isLearnPaused;
		if (this.isLearnPaused ||
				this.currentPhraseIndex === (this.phrases.length - 1))
			this.setState(this.getCurrentState());
		else
			this.setState(this.getNextState());
	}

	finishLearn() {
		if (this.intervalBetweenPhrases !== parseInt(
				CommonFunctions.getSetting(
				'intervalBetweenPhrases', '4'), 10))
			CommonFunctions.saveSetting(
					'intervalBetweenPhrases', this.intervalBetweenPhrases);
		this.isLearnPaused = true;
		this.props.app.setState({ mode: 'mainPanel' });
	}

	render() {
		return (
			<div>
				<div
						style={{
							cursor: 'pointer',
							marginTop: 30,
							fontSize: 'xx-large' }}
						onClick={this.readCurrentPhrase}>
					{ this.state.currentPhrase[0] }
				</div>
				<div style={{ marginTop: 10, color: 'green' }}>
					{ this.state.currentPhrase[1] }
				</div>

				<div style={{ textAlign: 'left',
							  width: '100%',
							  position: 'absolute',
							  bottom: 10 }}>
					<div style={{ marginLeft: 10, marginRight: 10 }}>
						<button onClick={this.goToPreviousPhrase}>
							Previous
						</button>
						<button onClick={this.goToNextPhrase}>Next</button>

						<button
								style={{ marginLeft: 10 }}
								onClick={this.resumeOrPauseLearn}>
							{ this.state.isLearnPaused ? 'Resume': 'Pause' }
						</button>

						<span style={{ marginLeft: 30 }}>
							Interval:
							<input
								type="number"
								style={{ width: 50 }}
								min="0"
								max="60"
								title="Interval between phrases"
								defaultValue={this.intervalBetweenPhrases}
								onChange={(event) => {
										this.intervalBetweenPhrases =
											parseInt(event.target.value, 10);
									}} /> s
						</span>

						<span style={{ marginLeft: 30 }}>
							{(this.state.currentPhraseIndex + 1) + ' / ' +
									this.phrases.length}
						</span>

						<button
								style={{ float: 'right' }}
								onClick={this.finishLearn}>
							Finish
						</button>
					</div>
				</div>
			</div> );
	} // render
} // class LearnPanel



// WEBPACK FOOTER //
// ./src/LearnPanel.js